import { Component, Output, EventEmitter, Inject, OnInit, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { Subject } from 'rxjs';
import { QnSbnDataService } from '../../../services/qn-sbn-data-service.service';
import { CfFtDialogService } from './cf-ft-dialog.service';

@Component({
  selector: 'dl-cf-feedback-template-dialog',
  templateUrl: './cf-feedback-template-dialog.component.html',
  styleUrls: ['./cf-feedback-template-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CfFeedbackTemplateDialogComponent implements OnInit {
  public templateColumn: any;
  public templateData: any;
  public newFeedbackOption: Subject<any> = new Subject<any>();
  public isAffBtnDisabled = true;
  public isNtBtnDisabled = false;
  public isNewFromTemplate = true;
  public selectedRow = [];
  public constructor(private cfFtDialogService: CfFtDialogService, private readonly dialog: MatDialog, public dialogRef: MatDialogRef<CfFeedbackTemplateDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private readonly oneSnackBar?: OneSnackBarService) {}

  public ngOnInit(): void {
    this.templateColumn = this.data.columnData;
    this.templateData = this.data.tableData;
   
  }

  public newTemplateClicked(): void {
    this.isAffBtnDisabled = true;
    this.isNtBtnDisabled = true;
    this.templateData = [
      {
        dragHandle: '',
        select: '',
        selectType: '',
        selectText: '',
        selectMandatory: '',
        iconSets: 'yes-icon' // value should be 'yes-icon, more-icon, delete-icon'
      }
    ];
    const newFeedbackDataSource = {
      templateData: this.templateData,
      placement: 'before'
    };
    this.newFeedbackOption.next(newFeedbackDataSource);
  }

  public feedbackOptionAdded(isAdded: boolean): void {
    this.isAffBtnDisabled = isAdded;
    this.isNtBtnDisabled = !isAdded;
  }

  public addFeedbackToForm(): void {
    // TODO: need API integration

    const newData = {
      newColumnData: ['dragHandle', 'selectType', 'selectText', 'selectMandatory', 'iconSets'],
      newTableData: this.selectedRow.map(item => {
        return {
          dragHandle: item.dragHandle,
          selectType: item.selectType,
          selectText: item.selectText,
          selectMandatory: item.selectMandatory,
          iconSets: 'more-icon'
        };
      })
    };
    // console.log('selected row' + newData);
    this.dialogRef.close({ data: newData });
    this.oneSnackBar.open('Feedback option successfully added', OneSnackBarType.SUCCESS);
  }

  public getSelectedRowInTemplate(rows: any): void {
    this.selectedRow = rows.foSelected;
    const isSelected = this.selectedRow.length > 0;
    this.isAffBtnDisabled = !isSelected;
    this.isNtBtnDisabled = isSelected;
  }
}
